import { Component, ContentChild, HostListener, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, TemplateRef, ViewChildren, ViewChild, ElementRef, OnChanges, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Constants } from "src/app/_consts/constants";
import { SharedService } from "src/app/_shared/shared.service";
import dateFormats from "../../const/date-formats";
import { SortableHeader, SortEvent } from "../../directives/sortable.directive";
import { Fce } from "../../fce";
import { HttpPlus } from "../../http-plus";
import moment from "moment";


@Component({
  selector: 's-table[cols]',
  templateUrl: './s-table.component.html',
  styleUrls: ['./s-table.component.scss']
})
export class STableComponent implements OnInit, OnChanges, OnDestroy {

  @Input() cols: any[] = [];
  @Input() mobileDivs: any[] = [];
  @Input() mobileSearchAttr: string;
  @Input() refreshUrl: string;
  @Input() detailUrl: string;
  @Input() detailId: string;
  @Input() params: any;
  @Input() hidePaginator: boolean = false;
  @Input() staticRows: any;
  @Input() defaultSearch: any = {};
  @Input() disableDefault: boolean = false;
  @Input() excel: boolean = false;
  @Input() hideRows: boolean = false;
  @Input() hideSearch: boolean = false;
  @Input() convertOrig: boolean = false;
  @Input() convertStatic: boolean = true;
  @Input() resizable: boolean = !this.shared.isMobile();
  @Input() showCount: boolean = false;
  @Input() showLoop: boolean = false;
  @Input() showPageSize: boolean = true;
  @Input() listOnMobile: boolean = false;
  @Input() alwaysList: boolean = false;
  @Input() quietLoad: boolean = false;
  @Input() skipFirstRefresh: boolean = false;
  @Input() loopTime: number = 30;
  @Input() refreshCounter: number = null;
  @Input() headerFixed: boolean = true;
  @Input() headerWhite: boolean = true;
  @Input() allowCheckboxed: boolean = false;
  @Input() noRowsText: string = 'no_rows_found';

  @Output() selected = new EventEmitter();
  @Output() onResponse = new EventEmitter();
  @Output() onRowsRaw = new EventEmitter();
  @Output() onRows = new EventEmitter();
  @Output() onClearFilters = new EventEmitter();
  @Output() onInit = new EventEmitter();
  @ViewChildren(SortableHeader) headers: QueryList<SortableHeader>;

  @ContentChild('slotTh', { static: false }) slotTh: TemplateRef<any>;
  @ContentChild('slotTd', { static: false }) slotTd: TemplateRef<any>;
  @ContentChild('slotRow', { static: false }) slotRow: TemplateRef<any>;
  @ContentChild('slotDiv', { static: false }) slotDiv: TemplateRef<any>;
  @ViewChild('tableContainer', { static: false }) tableContainer: ElementRef;
  @ViewChild('paginatorContainer', { static: false }) paginatorContainer: ElementRef;

  @HostListener('window:resize', ['$event'])
  resizeTable() {
    this.listView = (this.shared.isMobile() && this.listOnMobile) || this.alwaysList
    if (this.resizable && this.tableContainer && this.paginatorContainer) {
      const vh = window.innerHeight
      const th = this.tableContainer.nativeElement?.offsetTop
      const fh = this.paginatorContainer.nativeElement?.offsetHeight
      this.tableContainer.nativeElement.style.height = (vh > Constants.TABLE_FIXED_FROM_H && th && fh) ?
        `${vh - th - fh - Constants.IFTRAME_PADDING_PX}px` : 'auto'
    }
  }

  @HostListener('document:click', ['$event'])
  clickout() {
    this.loopCounter = 0
  }

  public rows: any[];
  public rowsOrig: any[];
  public paginator = {
    totalRows: 0,
    page: 1,
    pageSize: 50,
    sorts: [],
    loop: false
  }
  sortsMap = {};
  public search: any = {};
  public customSearch: any;
  public itemsPerPageOptions = Constants.ITEMS_PER_PAGE;
  lastSearch = null;
  lastParams = {};
  sums = null;
  avgs = null;
  langWatcher: Subscription
  loopTimer: any
  loopCounter: number = 0
  quietLoading: boolean = false
  rowStaticClass: string = ''
  listView: boolean = false
  allChecked: boolean = false
  firstRefresh: boolean = true
  paginatorSize: string = this.shared.isMobileConst ? 'md' : 'sm'
  paginatorMaxPages: number = this.shared.isMobileConst ? 3 : 10
  dateRangeTmp: { from?: string | null, to?: string | null } = null;
  private attrsDate: string[]
  private attrsNotDate: string[]
  dateIntervalBtns = Constants.DATE_FILTER_BTNS.filter(b => b !== 'all');

  constructor(protected http: HttpPlus, public shared: SharedService, protected router: Router) {
  }

  ngOnInit(): void {
    this.listView = (this.shared.isMobile() && this.listOnMobile) || this.alwaysList

    this.search = { ...this.defaultSearch }
    this.attrsDate = [];
    this.attrsNotDate = [];
    this.cols.forEach(c => {
      c.disabled = this.disableDefault && this.defaultSearch[c.attr]
      if (Constants.DATE_TYPES.includes(c.searchType || c.type))
        this.attrsDate.push(c.attr);
      else
        this.attrsNotDate.push(c.attr);
    })

    if (this.staticRows) {
      this.rows = Fce.copy(this.staticRows)
      this.rowsOrig = Fce.copy(this.staticRows)
      if (this.convertStatic)
        this.rows = Fce.convertToStaticArray(this.rows, this.cols, this.shared.transService)
    } else {
      if (this.params?.skipFirstRefresh)
        this.params.skipFirstRefresh = false
      else if (this.skipFirstRefresh)
        this.skipFirstRefresh = false
      else
        this.refresh();

      this.langWatcher = this.shared.transService.onLangChange.subscribe(() => {
        if (this.rowsOrig)//It means that the table was already loaded, fix double load
          this.refresh(true)
      })
    }
    this.resizeTable()
    this.rowStaticClass = this.detailUrl ? 'cursor' : ''
    this.onInit.emit(this)
  }

  ngOnChanges(): void {
    this.resizeTable()
    this.cols.forEach(c => {
      if (!c.searchAttr)
        c.searchAttr = c.attr;
    })
  }

  ngOnDestroy(): void {
    if (this.langWatcher)
      this.langWatcher.unsubscribe()
    if (this.loopTimer)
      clearInterval(this.loopTimer)
  }


  async refresh(forceReload: boolean = false) {
    if (this.staticRows)
      return this.refreshStaticRows()
    if (!this.refreshUrl)
      return

    const params: any = {
      search: Fce.convertForServer(Fce.removeNullParams(Fce.copy(this.search)), this.attrsNotDate),
      date_types: this.attrsDate,
      custom_search: Fce.convertForServer(Fce.removeNullParams(Fce.copy(this.customSearch))),
      paginator: this.hidePaginator ? {
        sorts: this.paginator.sorts,
      } : this.paginator,
      getLastSearch: !this.lastSearch && (!this.defaultSearch || Object.keys(this.defaultSearch).length === 0),
      listView: this.listView
    }
    if (this.params)
      Object.assign(params, this.params)
    if (this.quietLoad) {
      params.hideLoader = true
      this.quietLoading = true
    }
    if (!forceReload && Fce.compareObjects(params, this.lastParams, ["totalRows"])) {
      console.log("NO REFRESH - SAME PARAMS");
      this.quietLoading = false
      return;
    }
    console.log("TABLE REFRESH", params);
    this.lastParams = JSON.parse(JSON.stringify(params))

    const response: any = await this.http.post(this.refreshUrl, params);
    this.quietLoading = false
    if (!response)
      return
    console.log("TABLE RESPONSE", response);
    this.rowsOrig = this.convertOrig ? Fce.convertForClientArray(Fce.copy(response.rows)) : Fce.copy(response.rows)
    this.onResponse.emit(response)
    this.onRowsRaw.emit(response.rows)
    if (response.sums) {
      this.sums = Fce.convertToStatic(response.sums, this.cols, this.shared.transService)
      if (!response.avgs)
        this.avgs = {}
    }
    if (response.avgs) {
      this.avgs = Fce.convertToStatic(response.avgs, this.cols, this.shared.transService)
      if (!response.sums)
        this.sums = {}
    }
    const rows = this.convertStatic ? Fce.convertToStaticArray(response.rows, this.cols, this.shared.transService) : response.rows
    this.onRows.emit(rows)
    this.rows = rows

    if (params.getLastSearch) {
      console.log("LAST SEARCH", response.lastSearch)
      this.lastSearch = Fce.convertForClient(response.lastSearch || {})
      if (this.lastSearch.search) {
        this.search = {
          ...Fce.convertForClient(this.lastSearch.search, this.attrsNotDate),
          ...this.defaultSearch
        }
      }
      if (this.lastSearch.paginator)
        this.paginator = { ...this.paginator, ...this.lastSearch.paginator }

      this.paginatorLoop(false)
    }
    this.paginator.totalRows = response.count;
    this.sortsMap = Object.fromEntries(this.paginator?.sorts?.map(s => [s.by, s.dir]));

    console.log("TABLE ROWS", this.rows, this.rowsOrig)

    this.resizeTable()
    if (this.firstRefresh) {
      this.firstRefresh = false

      const savedScroll = this.shared.storageGet(`${this.refreshUrl}_scroll`);
      if (savedScroll) {
        requestAnimationFrame(() => {
          if (this.tableContainer?.nativeElement)
            this.tableContainer.nativeElement.scrollTop = +savedScroll;
          this.resizeTable()
        });
      }
    }
  }

  refreshStaticRows() {
    let rows = Fce.copy(this.staticRows)

    for (const key in this.search) {
      const val = `${this.search[key]}`.toLowerCase()
      rows = rows.filter(row => {
        if (Fce.empty(val))
          return true
        if (row[key] && `${row[key]}`.toLowerCase().includes(val))
          return true
        return false
      })
    }

    if (this.paginator.sorts && this.paginator.sorts.length > 0) {
      rows = rows.sort((a, b) => {
        for (const sort of this.paginator.sorts) {
          const valA = `${a[sort.by]}`.toLowerCase();
          const valB = `${b[sort.by]}`.toLowerCase();
          const compare = valA.localeCompare(valB);
          if (compare !== 0) {
            return sort.direction === 'DESC' ? -compare : compare;
          }
        }
        return 0; // všechny hodnoty jsou stejné
      });
    }

    this.rowsOrig = rows
    this.rows = rows
    if (this.convertStatic)
      this.rows = Fce.convertToStaticArray(this.rows, this.cols, this.shared.transService)
  }

  onSort({ by, dir }: SortEvent) {
    if (!this.paginator.sorts)
      this.paginator.sorts = [];
    const existingSort = this.paginator.sorts.find(s => s.by === by);
    if (existingSort) {
      existingSort.dir = dir;
    } else {
      this.paginator.sorts.push({ by, dir });
    }

    this.paginator.sorts = this.paginator.sorts.filter(s => !Fce.empty(s.dir));
    this.sortsMap = Object.fromEntries(this.paginator?.sorts?.map(s => [s.by, s.dir]));
    this.refresh();
  }

  selectRow(index: number, event: MouseEvent) {
    // Zamez akci, pokud uživatel označuje text
    const selection = window.getSelection()?.toString();
    if (selection && selection.length > 0) {
      const cleanText = selection
        .split('\n')
        .map(line => line
          .split(/\t+|\s{2,}/)
          .map(col => col.trim())
          .filter(col => col.length > 0)
          .join(' ')
        )
        .filter(line => line.length > 0)
        .join('\n');
      this.shared.writeClipboard(cleanText);
      return;
    }

    if (!this.rowsOrig || !this.rowsOrig[index])
      return
    const row = this.convertOrig ? { ...this.rowsOrig[index] } : Fce.convertForClient({ ...this.rowsOrig[index] });
    const rowTable = this.rows[index]
    console.log("SELECTED ROW", row);

    if (this.detailUrl && this.detailId) {
      this.router.navigate([`${this.detailUrl}/${row[this.detailId]}`]);
    } else {
      this.selected.emit({ row, rowTable, event });
    }
  }

  cancelFilters(refresh: boolean = true, emitEvent: boolean = true) {
    this.search = { ...this.defaultSearch }
    this.paginator.page = 1
    this.paginator.sorts = []
    this.sortsMap = {}
    if (emitEvent)
      this.onClearFilters.emit()
    if (refresh)
      this.refresh()
  }

  async exportExcel() {
    if (!this.refreshUrl)
      return

    const params: any = {
      search: Fce.convertForServer(Fce.removeNullParams(Fce.copy(this.search)), this.attrsNotDate),
      date_types: this.attrsDate,
      custom_search: Fce.convertForServer(Fce.removeNullParams(Fce.copy(this.customSearch))),
      action: this.refreshUrl,
      cols: this.cols,
      paginator: this.paginator,
    }

    if (this.params)
      Object.assign(params, this.params)

    const response: any = await this.http.post(`excel`, params);
    console.log("RESP", response)
    if (response && response.filename) {
      Fce.download(this.http, response.filename)
    }
  }

  addRow(row, index = this.rows.length, convertToStatic: boolean = true, scrollTo: boolean = false) {
    if (index == null)
      index = this.rows.length
    this.rows.splice(index, 0, convertToStatic ? Fce.convertToStatic({ ...row }, null, this.shared.transService) : row)
    this.rowsOrig.splice(index, 0, row)
    if (scrollTo) {
      this.scrollToNew();
    }
  }

  scrollToNew() {
    const index = this.rows.findIndex(r => r.isNew);
    if (index == -1) return;

    requestAnimationFrame(() => {
      if (!this.tableContainer?.nativeElement) return;

      const tbody = this.tableContainer.nativeElement.querySelector('tbody');
      if (!tbody) return;

      const rowEl = tbody.children[index] as HTMLElement;
      if (rowEl) {
        rowEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  removeRow(index) {
    this.rows.splice(index, 1)
    this.rowsOrig.splice(index, 1)
  }

  paginatorLoop(clicked: boolean) {
    if (clicked)
      this.paginator.loop = !this.paginator.loop

    if (this.loopTimer) {
      clearInterval(this.loopTimer)
      this.loopTimer = null
    }

    if (this.paginator.loop) {
      this.loopCounter = 0
      this.loopTimer = setInterval(() => {
        this.loopCounter++
        if (this.loopCounter >= this.loopTime && this.tableContainer) {
          const pageCount = Math.ceil(this.paginator.totalRows / this.paginator.pageSize)
          this.paginator.page = (this.paginator.page + 1) % (pageCount + 1)
          if (this.paginator.page === 0)
            this.paginator.page = 1
          this.refresh(true)
          this.paginatorLoop(false)
        }
      }, 1000)
    }
  }

  getTdClasses(col, row) {
    let tmp
    if (col.tdClass)
      tmp = col.tdClass
    if (row['tdClass_' + col.attr]) {
      if (tmp) {
        tmp += ' ' + row['tdClass_' + col.attr]
      } else {
        tmp = row['tdClass_' + col.attr]
      }
    }
    return tmp
  }

  checkAllRows(value) {
    this.rows.forEach(r => {
      r.checked = !!value
    })
  }

  getCheckedRows() {
    return this.rows.filter(r => r.checked)
  }

  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target || !this.refreshUrl)
      return
    this.shared.storageSet(`${this.refreshUrl}_scroll`, target.scrollTop.toString());
  }

  formatDateRange(value: string | null): string {
    if (!value || !value.split) return '';

    const [fromRaw, toRaw] = value.split(',');

    const from = fromRaw && fromRaw !== '#' ? moment(fromRaw).format(dateFormats.DATE) : '';
    const to = toRaw && toRaw !== '#' ? moment(toRaw).format(dateFormats.DATE) : '';

    if (from && to) return `${from} → ${to}`;
    if (from && !to) return `${from} → #`;
    if (!from && to) return `# ← ${to}`;
    return '';
  }

  clearDateRange(attr: string) {
    this.search[attr] = null;
    this.dateRangeTmp = null;
    this.refresh();
  }

  applyDateRange(attr: string) {
    const temp = this.dateRangeTmp || {};
    this.search[attr] = `${temp.from || '#'},${temp.to || '#'}`;
    this.refresh();
  }

  onDropdownDate(isOpen: boolean, attr: string) {
    if (isOpen) {
      this.dateRangeTmp = { from: null, to: null };
      if (this.search[attr]) {
        const [from, to] = this.search[attr].split(',');
        this.dateRangeTmp.from = from || null;
        this.dateRangeTmp.to = to || null;
      }
    }
  }

  selectDateInterval(type: string, attr: string) {
    const dateFrom = moment().startOf('day')
    const dateTo = moment().endOf('day')

    switch (type) {
      case "today":
        break;
      case "yesterday":
        dateFrom.add(-1, 'day')
        dateTo.add(-1, 'day')
        break;
      case "this_week":
        dateFrom.startOf('isoWeek')
        dateTo.endOf('isoWeek')
        break;
      case "last_week":
        dateFrom.add(-1, 'week').startOf('isoWeek')
        dateTo.add(-1, 'week').endOf('isoWeek')
        break;
      case "this_month":
        dateFrom.startOf('month')
        dateTo.endOf('month')
        break;
      case "last_month":
        dateFrom.add(-1, 'month').startOf('month')
        dateTo.add(-1, 'month').endOf('month')
        break;
      case "this_year":
        dateFrom.startOf('year')
        dateTo.endOf('year')
        break;
      case "last_year":
        dateFrom.add(-1, 'year').startOf('year')
        dateTo.add(-1, 'year').endOf('year')
        break;
    }
    this.search[attr] = `${dateFrom.format(dateFormats.DEFAULT)},${dateTo.format(dateFormats.DEFAULT)}`;
    this.refresh();
  }
}
